import { useEffect, useState } from 'react';
import moment from 'moment';
import { registerLocale } from 'react-datepicker';

import { getLanguageCodeFromLocale } from 'helpers/localization.js';
import { DEFAULT_LOCALE } from 'contexts/LocalizationContext.jsx';

const useLocaleMomentAndDateFNS = ({ locale }) => {

  const [momentLocale, setMomentLocale] = useState();
  const [dateFNSLocale, setDateFNSLocale] = useState();
  const [dateFNSLocaleModule, setDateFNSLocaleModule] = useState();

  useEffect(() => {
    if (!locale) return;

    const languageCode = getLanguageCodeFromLocale(locale);
    import(`moment/locale/${locale.toLowerCase()}`)
      .then(() => {
        setMomentLocale(locale);
      })
      .catch(() => {
        import(`moment/locale/${languageCode}`)
          .then(() => {
            setMomentLocale(languageCode);
          })
          .catch(() => {
            console.warn(`Failed to load a moment ${locale} for ${languageCode}`);
            setMomentLocale(DEFAULT_LOCALE);
          });
      });

    import(`date-fns/locale/${locale}/index.js`)
      .then((localeModule) => {
        registerLocale(locale, localeModule);
        setDateFNSLocale(locale);
        setDateFNSLocaleModule(localeModule);
      })
      .catch(() => {
        import(`date-fns/locale/${languageCode}/index.js`)
          .then((localeModule) => {
            registerLocale(languageCode, localeModule);
            setDateFNSLocale(languageCode);
            setDateFNSLocaleModule(localeModule);
          }).catch(() => {
            setDateFNSLocale(DEFAULT_LOCALE);
            console.warn(`Failed to load a date-fns locale ${locale} for ${languageCode}`);
          });
      });
  }, [locale]);

  useEffect(() => {
    moment.locale(momentLocale);
  }, [momentLocale]);

  return {
    momentLocale,
    dateFNSLocale,
    dateFNSLocaleModule,
  };
};

export default useLocaleMomentAndDateFNS;
